// Copy this file to local.js on deploy to production

module.exports = (oldConf) => {
    oldConf.api.baseURL = "https://api.culture-labs.eu"
    oldConf.facebook = true
    oldConf.api.notificationReloadTime = 15000
    return oldConf
}



//////////////////
// WEBPACK FOOTER
// ./config/local.js
// module id = mMs5
// module chunks = 1